module.exports = __webpack_public_path__ + "images/content-whiteware.5c1cc6417ae279a0e95191c2db5ad97a.svg";